import { NgModule } from "@angular/core";
import { MatSpinnerOverlayComponent } from "./mat-spinner-overlay.component";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
    declarations: [MatSpinnerOverlayComponent],
    // export the NgModule-based component
    imports: [CommonModule, MatProgressSpinnerModule],
    exports: [MatSpinnerOverlayComponent], 
  })
  export class MatSpinnerOverlayModule {
  
  }